module.exports = __webpack_public_path__ + "src/assets/games/43/232.jpg";